import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private headerImageSubject = new BehaviorSubject<string | null>(null);
  private sidebarIconSubject = new BehaviorSubject<string | null>(null);

  get headerImage$(): Observable<string | null> {
    return this.headerImageSubject.asObservable();
  }

  setHeaderImage(src: string | null): void {
    this.headerImageSubject.next(src);
  }

  get sidebarIcon$(): Observable<string | null> {
    return this.sidebarIconSubject.asObservable();
  }

  setSidebarIcon(src: string | null): void {
    this.sidebarIconSubject.next(src);
  }
}
